/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DashboardPartialExcludingCreationInfoUpdateInfoStateHistoryId } from '../models/dashboard-partial-excluding-creation-info-update-info-state-history-id';
import { DashboardWithRelations } from '../models/dashboard-with-relations';

@Injectable({ providedIn: 'root' })
export class DashboardControllerService extends DataBaseService {

  /**
   * Path part for operation dashboardControllerUpdateById
   */
  static readonly DashboardControllerUpdateByIdPath = '/v1/dashboards/{id}';

  /**
   * Update dashboard by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DashboardPartialExcludingCreationInfoUpdateInfoStateHistoryId
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DashboardControllerService.DashboardControllerUpdateByIdPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Update dashboard by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DashboardPartialExcludingCreationInfoUpdateInfoStateHistoryId
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dashboardControllerFind
   */
  static readonly DashboardControllerFindPath = '/v1/dashboards';

  /**
   * Get all dashboards
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DashboardWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DashboardControllerService.DashboardControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DashboardWithRelations>>;
      })
    );
  }
  /**
   * Get all dashboards
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DashboardWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DashboardWithRelations>>) => r.body as Array<DashboardWithRelations>)
    );
  }

}
